<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="title">
          <el-breadcrumb-item>
            <a href="javascript:void(0);" @click="$router.push('/user/psyTest')" class="aHref">心理测试</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>测试详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="formUserInfo">
          <div class="cnHomeTabsItem flex">
            <div class="avatar img" :style="'backgroundImage: url('+details.exam.exhibitImg+')'"></div>
            <div class="rightHome">
              <div class="flex">
                <span><strong>{{ details.exam.title }}</strong></span>
                <span>测试单号：{{ no }}</span>
              </div>
              <p>
                <span>测试费用：<span class="cost">￥{{ details.expense }}</span></span>
              </p>
              <div class="flex">
                <span
                    :class="(details.examStatus==1||details.examStatus==2)?'cost':'green'">{{
                    details.examStatus | statusFmt
                  }}</span>
                <el-button v-if="details.examStatus==0" size="mini" class="solid"
                           @click="toExamDetails(details.exam.id)">去测试
                </el-button>
              </div>
            </div>
          </div>
          <div class="cnHomeTabsItem  resultItem">
<!--            <p class="infoTit">系统测试分析测试结果</p>-->
            <strong class="resultScore">测试得分: <span>{{ data.result.score }}</span>分</strong>
            <p class="resultTitle">测试结果:{{ data.analysis.title }}</p>
            <p v-if="data.analysis.title">
              {{ data.analysis.scoreRangeMin }}~{{ data.analysis.scoreRangeMax }}分:{{ data.analysis.analysisDesc }}
            </p>
            <span v-else style="color: #AAA;">暂无</span>
            <p>{{ data.exam.briefDesc }}</p>
          </div>
          <div class="cnHomeTabsItem ">
            <p class="infoTit">答题详情</p>
            <div v-for="resultOption in data.resultOptionList" :key="resultOption.examSubject.index">
              {{ resultOption.examSubject.title }}<br><br>
              <!--单选-->
              <div v-if="resultOption.examSubject.subjectType===1">
                <el-radio
                    disabled
                    v-model="answer[resultOption.examSubject.index-1]"
                    :label="subjectOption.id"
                    v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                    :key="subjectOption.id">
                  {{ subjectOption.title }}
                </el-radio>
              </div>
              <!--判断-->
              <div v-else-if="resultOption.examSubject.subjectType===2">
                <el-radio
                    disabled
                    v-model="answer[resultOption.examSubject.index-1]"
                    :label="subjectOption.id"
                    v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                    :key="subjectOption.id">
                  {{ subjectOption.title }}
                </el-radio>
              </div>
              <!--多选-->
              <div v-else-if="resultOption.examSubject.subjectType===3">
                <el-checkbox-group v-model="answer[resultOption.examSubject.index-1]">
                  <el-checkbox
                      disabled
                      v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                      :key="subjectOption.id"
                      :label="subjectOption.id">
                    {{ subjectOption.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <!--填空-->
              <div v-else-if="resultOption.examSubject.subjectType===4">
                <el-input disabled v-model="answer[resultOption.examSubject.index-1]"
                          placeholder="请输入内容"></el-input>
              </div>
              <!--问答-->
              <div v-else>
                <el-input
                    disabled
                    type="textarea"
                    autosize
                    placeholder="请输入内容"
                    v-model="answer[resultOption.examSubject.index-1]">
                </el-input>
              </div>
              <br>
            </div>
          </div>
          <div class="cnHomeTabsItem " v-if="details.result">
            <p class="infoTit">测试结果</p>
            <div class="appointInfo testResults">
              {{ details.result ? details.result : '暂无' }}
            </div>
          </div>
          <div class="cnHomeTabsItem" v-if="details.examStatus>1">
            <p class="infoTit">评价</p>
            <div class="appointInfo">
              <span v-if="details.examStatus==3">{{ details.evaluate }}</span>
              <div v-else>
                <el-checkbox v-model="syncAssess.isSync">公开评价</el-checkbox>
                <el-checkbox v-if="syncAssess.isSync" v-model="syncAssess.isAnonymous">匿名</el-checkbox>
                <div class="evaluation">
                  <el-input
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 5}"
                      placeholder="请输入评价内容"
                      v-model="evaluate">
                  </el-input>
                  <el-button :loading="loading" class="submitBtn" size="mini" @click="submitEvaluate">
                    提交
                  </el-button>
                  <div style="clear: both"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';
import qs from 'qs';

export default {
  name: "psyTestDetail",
  data() {
    return {
      no: this.$route.query.no,
      details: {exam: {}},

      loading: false,
      evaluate: '',

      syncAssess: {
        isSync: false,
        isAnonymous: false,
      },

      data: {
        analysis: {},
        exam: {},
        result: {
          score: '',
        },
        resultOptionList: {},
      },

      answer: [],
    }
  },
  components: {
    'tabCommon': () => import('./tabCommon'),
  },
  mounted() {
    if (this.no) {
      this.getData();
    } else {
      this.$router.back();
    }
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax
          .get(base.api.exam.result.detailByNo.replace("{resultNo}", this.no))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.data;
              $(res.data.data.resultOptionList).each((index, obj) => {
                switch (obj.examSubject.subjectType) {
                  case 1:
                    that.answer[index] = parseInt(obj.answers);
                    break;
                  case 2:
                    that.answer[index] = parseInt(obj.answers);
                    break;
                  case 3:
                    that.answer[index] = obj.answers.split(',').map(Number);
                    break;
                  case 4:
                    that.answer[index] = obj.answers;
                    break;
                  case 5:
                    that.answer[index] = obj.answers;
                }
              });
              // analyses 为空时
              if (!that.data.analysis) {
                that.data.analysis = {};
              }

              that.$ajax.get(base.api.exam.result.details.replace("{no}", that.no)).then((res) => {
                if (res.data.status === 'success') {
                  that.details = res.data.data;
                }
              })
            } else {
              that.$router.back();
            }
          })
    },
    toExamDetails(id) {
      this.$router.push({name: 'examDetail', query: {back: '1', id: id}});
    },
    submitEvaluate() {
      if (this.details && this.details.id) {
        if ($.trim(this.evaluate).length === 0) {
          this.$message.warning("评价内容不能为空");
          return;
        } else if ($.trim(this.evaluate).length > 300) {
          this.$message.warning("评价内容不能超过300个字符");
          return;
        }
        this.loading = true;
        let data = {
          msg: this.evaluate,
          type: 0
        };
        if (this.syncAssess.isSync) {
          if (this.syncAssess.isAnonymous) {
            data.type = 2;
          } else {
            data.type = 1;
          }
        }
        this.$ajax.post(base.api.exam.result.evaluate.replace("{no}", this.no), qs.stringify(data)).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message);
            setTimeout('location.reload()', 2000);
          } else {
            this.$message.error(res.data.message);
            this.loading = false;
          }
        }).catch((err) => {
          console.error(err);
          this.$message.error('操作失败');
        });
      }
    }
  },
  filters: {
    statusFmt(status) {
      switch (status) {
        case 0:
          return "待测试";
        case 1:
          return "待结果";
        case 2:
          return "待评价";
        case 3:
          return "已完成";
      }
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.cnHomeTabsItem {
  .avatar {
    width: 150px;
    height: 75px;
  }

  .rightHome {
    width: calc(100% - 170px);
  }

  .testResults {
    text-indent: 2em;
  }
}

.evaluation button.submitBtn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.resultItem {
  line-height: 1.8;
  font-size: 14px;
}
</style>